import React from 'react'
import { withStyles } from "@mui/styles";
import {connect} from 'react-redux'
import {Route, Switch} from 'react-router-dom'
import AppBar from '@mui/material/AppBar'
import ExploreAppBar from './explore/ExploreAppBar'
import SocialAppBar from './social/SocialAppBar'
import SpacecastAppBar from './spacecast/SpacecastAppBar'
import SettingsAppBar from './settings/SettingsAppBar'
import AdminAppBar from './admin/AdminAppBar'
import LogoutAppBar from "./LogoutAppBar";
import {Button, Link} from "@mui/material";
import ContributorSettingsAppBar from "./settings/ContributorSettingsAppBar";

const styles = {
  appBar: {
    backgroundColor: '#003e58',
    display:'flex',
    flexDirection:'row',
    minHeight:'72px',
    // justifyContent:'space-between',
    '& div.MuiTabs-root':{
      flexGrow: 1,
      display:'flex',
      flexDirection:'row',
      gap:'1em',
      '& a.MuiTab-root':{
        minWidth:'7.5em',
        '&:hover': {
          textDecoration: 'none',
          backgroundColor: 'rgba(0, 0, 0, 0.3)'
        }
      }
    }
  },
  appBarRight: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 0,
    marginLeft: 'auto'
  },
  appBarWelcome: {
    marginRight:'1em',
    textAlign:'center',
    flexGrow: 0
  },
  logoButton: {
    minWidth: 'fit-content',
    height:'100%',
    boxSizing:'border-box',
    padding: '8px 1rem',
    marginRight: 'auto',
    alignSelf: 'center',
    '&:hover': {
      textDecoration: 'none',
      backgroundColor: 'rgba(0, 0, 0, 0.3)'
    }
  },
  logoImage: {
    height:'46px',
    alignSelf: 'center'
  }
}

const SecondaryAppBar = (props) => (
  <AppBar id="secondaryNav" position="static" className={props.classes.appBar}>
    <Switch>
      <Route exact path='/' component={ExploreAppBar}/>
      <Route path='/explore' component={ExploreAppBar}/>
      <Route path='/logout' component={LogoutAppBar}/>
      {/*<Route path='/profile' component={ProfileAppBar}/>*/}
      <Route path='/social' component={SocialAppBar}/>
      <Route path='/spacecast' component={SpacecastAppBar}/>
      {props.user.is_admin ? <Route path='/admin' component={AdminAppBar}/> : null}
      {(props.mindfile.owner === props.user.uid) ? <Route path='/settings' component={SettingsAppBar}/> : null}
      {(props.mindfileUserLevel <= 2) ? <Route path='/contributor-settings' component={ContributorSettingsAppBar}/> : null}
    </Switch>
    <div className={props.classes.appBarRight}>
      <div id="lifenautWelcome" className={props.classes.appBarWelcome}>
        Welcome<br/>
        {props.user.username}
      </div>
      <Button id="lifenautLogoButton" color='inherit' className={props.classes.logoButton} component={Link} href="/">
        <img alt="LifeNaut" src="/v2/images/lifenaut-logo-dark-trans.png" className={props.classes.logoImage}/>
      </Button>
    </div>
  </AppBar>
)

const mapStateToProps = state => ({
  mindfile: state.mindfile,
  user: state.auth,
  mindfileUserLevel: state.mindfileUserLevel.level,
});

export default connect(mapStateToProps)(withStyles(styles)(SecondaryAppBar))
